// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3IrxY","expandIcon":"AccordionButton_expandIcon__ENZh3","expanded":"AccordionButton_expanded__2WMaW"};